// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sugestion {
    background: var(--white-color);
    border-radius: 6px;
    border: 1px solid var(--new-gray-background-color);
    height: fit-content;
}
.sugestion__content {
    padding: 24px;
}
.sugestion__content__attributes {
    width: var(--space-x3);
    height: var(--space-x3);
    min-width: var(--space-x2);
    min-height: var(--space-x2);
    display: contents;
    background: var(--primary-light-color);
    /* padding: var(--space-quarter); */
}

.sugestion__content__attributes__data{
    cursor: pointer;
}

.sugestion__content__attributes__info {
   margin-top: 24px;
}

.sugestion__content__attributes__photo{
    width: 55px;
    height: 55px;
    margin: 0 auto;
    display: flex;
    align-items: center;
}
.sugestion__content__attributes__photo img {
    width: 55px;
    height: 55px;
    border-radius: 50%;
}

.sugestion__content__attributes__photo .icon-ball{
    font-size: 46px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 4px;
    height: 54px;
    color: var(--white-color);
}

.sugestion__content__title__text {
    text-align: center;
}

.sugestion__content__title__text.baloa-normal-medium{
    color: var(--primary-very-dark-color);
}

.sugestion__content__title__text.baloa-names{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.sugestion__content__footer_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
}

.sugestion__content__footer_btn .button.rounded-button.small {
    width: 100%;
}

.sugestion__content__field_create {
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 6px;
    color: var(--new-green-color);
    background: var(--white-color);
    border: 1px solid var(--new-green-color);
    padding: 8px 16px;
}

.sugestion__content__field_create.following{    
    background: #EAF7F0;
}

.sugestion__content__field__data-create {
    display: flex;    
    align-items: center;
    margin: 0 auto;
}
.sugestion__content__field__data__text_create.baloa-names {
    color: var(--new-green-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .sugestion {
        border-radius: 8px;
        border:none;
        margin: 8px 12px;
    }

    /*boton agregar*/
    .sugestions__mobile-content__page-info {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .sugestion__mobile-content {
        display: flex;        
        align-items: center;
    }

    .suggestions__mobile__list__page-item{
        height: 40px;
        width: 40px;
    }

    .sugestion__mobile-content__attributes__photo{
        width: 39px;
        height: 39px;
        margin: 0;
    }

    .sugestion__mobile-content__attributes__photo.icon-ball{
        font-weight: var(--font-bold);
        border-radius: 50%;
        color: var(--white-color);
        align-items: center;
        font-size: 31px;
        padding: 4px;
    }

    .sugestion__mobile-content__attributes__info {
        padding: 0%;
    }

    .sugestion__mobile-content__title__text{
        text-align:justify;
        /* flex-direction: column; */
        margin-left: 3px;
    }
    .sugestion__mobile-content__title__text.baloa-normal-medium{
        font-size: calc( var(--space) + var(--space-quarter) + 1px );
        white-space: break-spaces;
    }

    .hubicon-following_respon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        font-size: 40px;
        cursor: pointer;
    }

    .hubicon-follow_respon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        font-size: 40px;
        cursor: pointer;
    }

    .sugestions__mobile-content__page-info img {
        width: 39px;
        height: 39px;
        border-radius: 50%;
    }

    .sugestion__content {
        padding: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-groups-suggestions/SugestionComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kDAAkD;IAClD,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,iBAAiB;IACjB,sCAAsC;IACtC,mCAAmC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,6BAA6B;AACjC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;IACpB;;IAEA,gBAAgB;IAChB;QACI,aAAa;QACb,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,yBAAyB;QACzB,mBAAmB;QACnB,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;QAC5B,gBAAgB;IACpB;IACA;QACI,4DAA4D;QAC5D,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".sugestion {\n    background: var(--white-color);\n    border-radius: 6px;\n    border: 1px solid var(--new-gray-background-color);\n    height: fit-content;\n}\n.sugestion__content {\n    padding: 24px;\n}\n.sugestion__content__attributes {\n    width: var(--space-x3);\n    height: var(--space-x3);\n    min-width: var(--space-x2);\n    min-height: var(--space-x2);\n    display: contents;\n    background: var(--primary-light-color);\n    /* padding: var(--space-quarter); */\n}\n\n.sugestion__content__attributes__data{\n    cursor: pointer;\n}\n\n.sugestion__content__attributes__info {\n   margin-top: 24px;\n}\n\n.sugestion__content__attributes__photo{\n    width: 55px;\n    height: 55px;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n}\n.sugestion__content__attributes__photo img {\n    width: 55px;\n    height: 55px;\n    border-radius: 50%;\n}\n\n.sugestion__content__attributes__photo .icon-ball{\n    font-size: 46px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 4px;\n    height: 54px;\n    color: var(--white-color);\n}\n\n.sugestion__content__title__text {\n    text-align: center;\n}\n\n.sugestion__content__title__text.baloa-normal-medium{\n    color: var(--primary-very-dark-color);\n}\n\n.sugestion__content__title__text.baloa-names{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.sugestion__content__footer_btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 24px;\n}\n\n.sugestion__content__footer_btn .button.rounded-button.small {\n    width: 100%;\n}\n\n.sugestion__content__field_create {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    border-radius: 6px;\n    color: var(--new-green-color);\n    background: var(--white-color);\n    border: 1px solid var(--new-green-color);\n    padding: 8px 16px;\n}\n\n.sugestion__content__field_create.following{    \n    background: #EAF7F0;\n}\n\n.sugestion__content__field__data-create {\n    display: flex;    \n    align-items: center;\n    margin: 0 auto;\n}\n.sugestion__content__field__data__text_create.baloa-names {\n    color: var(--new-green-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .sugestion {\n        border-radius: 8px;\n        border:none;\n        margin: 8px 12px;\n    }\n\n    /*boton agregar*/\n    .sugestions__mobile-content__page-info {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n    }\n\n    .sugestion__mobile-content {\n        display: flex;        \n        align-items: center;\n    }\n\n    .suggestions__mobile__list__page-item{\n        height: 40px;\n        width: 40px;\n    }\n\n    .sugestion__mobile-content__attributes__photo{\n        width: 39px;\n        height: 39px;\n        margin: 0;\n    }\n\n    .sugestion__mobile-content__attributes__photo.icon-ball{\n        font-weight: var(--font-bold);\n        border-radius: 50%;\n        color: var(--white-color);\n        align-items: center;\n        font-size: 31px;\n        padding: 4px;\n    }\n\n    .sugestion__mobile-content__attributes__info {\n        padding: 0%;\n    }\n\n    .sugestion__mobile-content__title__text{\n        text-align:justify;\n        /* flex-direction: column; */\n        margin-left: 3px;\n    }\n    .sugestion__mobile-content__title__text.baloa-normal-medium{\n        font-size: calc( var(--space) + var(--space-quarter) + 1px );\n        white-space: break-spaces;\n    }\n\n    .hubicon-following_respon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-left: auto;\n        font-size: 40px;\n        cursor: pointer;\n    }\n\n    .hubicon-follow_respon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-left: auto;\n        font-size: 40px;\n        cursor: pointer;\n    }\n\n    .sugestions__mobile-content__page-info img {\n        width: 39px;\n        height: 39px;\n        border-radius: 50%;\n    }\n\n    .sugestion__content {\n        padding: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
